// validationUtils.js
export const validateFormData = (data) => {
  const errors = {};

  if (!data.name || data.name.trim() === '') {
    errors.name = 'Name is required';
  }

  // if (!data.email || !/\S+@\S+\.\S+/.test(data.email)) {
  //   errors.email = 'Invalid email address';
  // }

  if (!data.dateOfBirth || isNaN(Date.parse(data.dateOfBirth))) {
    errors.dateOfBirth = 'Invalid date of birth';
  }

  if (!data.mobileNo || !/^\d{10}$/.test(data.mobileNo)) {
    errors.mobileNo = 'Invalid mobile number';
  }

  if (data.mobileNo2 && !/^\d{10}$/.test(data.mobileNo2)) {
    errors.mobileNo2 = 'Invalid secondary mobile number';
  }

  if (!data.relativeName || data.relativeName.trim() === '') {
    errors.relativeName = 'Relative name is required';
  }

  if (!data.relationshipType || data.relationshipType.trim() === '') {
    errors.relationshipType = 'Relationship type is required';
  }

  if (!data.permanentAddress || data.permanentAddress.trim() === '') {
    errors.permanentAddress = 'Permanent address is required';
  }

  if (!data.localAddress || data.localAddress.trim() === '') {
    errors.localAddress = 'Local address is required';
  }

  // if (!data.uttarakhandBarId || data.uttarakhandBarId.trim() === '') {
  //   errors.uttarakhandBarId = 'Uttarakhand Bar ID is required';
  // }

  // if (!data.barAssociationId || isNaN(data.barAssociationId)) {
  //   errors.barAssociationId = 'Invalid Bar Association ID';
  // }

  if (!data.concernedBarRegistrationDate || isNaN(Date.parse(data.concernedBarRegistrationDate))) {
    errors.concernedBarRegistrationDate = 'Invalid concerned bar registration date';
  }

  if (!data.yearsOfExperience || isNaN(data.yearsOfExperience)) {
    errors.yearsOfExperience = 'Invalid years of experience';
  }

  if (!data.permanentAddress || data.permanentAddress.trim() === "") {
    errors.permanentAddress = 'Permanent address is required';
  }
  if (!data.localAddress || data.localAddress.trim() === "") {
    errors.localAddress = 'Local address is required';
  }
  // if (!data.advocacyDocuments || data.advocacyDocuments.trim() === "") {
  //     errors.advocacyDocuments = 'Advocacy documents are required';
  // }
  // if (!data.enrollmentNo || data.enrollmentNo.trim() === "") {
  //   errors.enrollmentNo = 'Enrollment number is required';
  // }
  // if (!data.enrollmentCertificate || data.enrollmentCertificate.trim() === "") {
  //     errors.enrollmentCertificate = 'Enrollment certificate is required';
  // }
  // if (!data.aibePassCertificateNo || String(data.aibePassCertificateNo).trim() === "") {
  //   errors.aibePassCertificateNo = 'AIBE pass certificate number is required';
  // } else if (isNaN(data.aibePassCertificateNo)) {
  //   errors.aibePassCertificateNo = 'AIBE pass certificate number must be a valid number';
  // }
  // if (!data.aibePassCertificate || data.aibePassCertificate.trim() === "") {
  //     errors.aibePassCertificate = 'AIBE pass certificate is required';
  // }
  // if (!data.copNo || String(data.copNo).trim() === "") {
  //   errors.copNo = 'COP number is required';
  // }
  // if (!data.copCertificate || data.copCertificate.trim() === "") {
  //     errors.copCertificate = 'COP certificate is required';
  // }
  // if (!data.copValitidy || isNaN(Date.parse(data.copValitidy))) {
  //   errors.copValitidy = 'Invalid COP validity date';
  // }

  // if (!data.aadharCertificate || data.aadharCertificate.trim() === "") {
  //     errors.aadharCertificate = 'Aadhar certificate is required';
  // }
  // if (typeof data.isAnotherBarMember !== 'boolean') {
  //   errors.isAnotherBarMember = 'Bar membership status must be a boolean';
  // }
  // if ((data.isAnotherBarMember === true) && (!data.barAssociationMembershipDetails || data.barAssociationMembershipDetails.trim() === "")) {
  //   errors.barAssociationMembershipDetails = 'Bar association membership details are required';
  // }
  // if (!data.mentorAdvocateName || data.mentorAdvocateName.trim() === "") {
  //   errors.mentorAdvocateName = 'Mentor advocate name is required';
  // }
  // if (!data.mentorAdvocateBarId || data.mentorAdvocateBarId.trim() === "") {
  //   errors.mentorAdvocateBarId = 'Mentor advocate bar ID is required';
  // }

  // if (!data.joiningDate || isNaN(Date.parse(data.joiningDate))) {
  //   errors.joiningDate = 'Valid joining date is required';
  // }
  // if (!data.chamberNo || data.chamberNo.trim() === "") {
  //   errors.chamberNo = 'Chamber number is required';
  // }


  if (!data.photo || data.photo.trim() === "") {
      errors.photo = 'Photo is required';
  }
  if (!data.fingerprintImage) {
      errors.fingerprintImage = 'Fingerprint is required';
  }
  // if (!data.signature || data.signature.trim() === "") {
  //     errors.signature = 'Signature is required';
  // }


  return errors;
};
